export default __webpack_public_path__ + "static/media/party.6acb3278.png";